import "./Client.css";
import NavMenu from "../../Components/NavMenu/ClientNavMenu";
import clientNavOptions, { accNavOptions, logoutNav } from "./clientNavOptions";
import img from "../../Assets/Images/userImage.png";
import User from "../../Services/User";
import { useNavigate, useLocation } from "react-router-dom";
import RouteView from "../../Routes/RouteView";
import { useState, useEffect } from "react";
import Url from "../../Services/Url";

const Client = ({ ModalAction }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [accNav, setNotify] = useState();
  const [trackingCode, setTrackingCode] = useState("");

  const biodata = User.getBiodata();

  useEffect(() => {
    //  Get tracking from navigation state or localStorage
    const tracking = User.getCompany().companyTrackingCode
    setTrackingCode(tracking);

    // Optionally save again in localStorage if it came from navigation
    if (tracking) {
      localStorage.setItem("tracking", tracking);
    }
   
    //  Set up account navigation
    setNotify(accNavOptions);
  }, [location.state]);

  logoutNav.navImg = img;
  if (biodata) {
    logoutNav.title = `${biodata.firstname} ${biodata.lastname}`;
  }

  const onOk = () => {
    localStorage.removeItem("tracking");
    localStorage.removeItem("companyId");
    localStorage.removeItem("companyCode");

    navigate("../");
  };

  logoutNav.confirm = {
    option: {
      title: "Logging out?",
      text: "You are about to logout from Fieldbase Tracker app",
      exitText: "Exit",
      okText: "Continue",
      onOk,
    },
    ModalAction,
  };

  return (
    <div className="Engineer">
      {accNav && (
        <>
          <NavMenu accNav={accNav} logout={logoutNav}>
            {clientNavOptions}
          </NavMenu>

          <RouteView
            ModalAction={ModalAction}
            emptyRoute={clientNavOptions[0]}
            
          >
            {[...clientNavOptions, ...accNavOptions]}
          </RouteView>
        </>
      )}
    </div>
  );
};

export default Client;
